module.exports = __webpack_public_path__ + "static/mindwave-flight-7611070347375628d2f5f5d1429e5622.gif";